module.exports = __webpack_public_path__ + "images/fsoel_vermoegensdepot_result_3.svg?6972785138867ea808db695ac73864b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fsoel_vermoegensdepot_result_3.svg
// module id = 26nK
// module chunks = 0